<!-- components/ToastAlert.vue -->
<template>
  <transition name="toast">
    <div v-if="isVisible" class="toast-alert" :class="typeClass">
      <div class="toast-content">
        <span class="toast-message">{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: "info", // success, error, warning, info
  },
  duration: {
    type: Number,
    default: 3000,
  },
});

const emit = defineEmits(["close"]);

const isVisible = ref(false);

const typeClass = computed(() => {
  return `toast-${props.type}`;
});

const show = () => {
  isVisible.value = true;
  window.setTimeout(() => {
    hide();
  }, props.duration);
};

const hide = () => {
  isVisible.value = false;
  window.setTimeout(() => {
    emit("close");
  }, 300);
};

onMounted(() => {
  show();
});
</script>

<style scoped>
.toast-alert {
  position: fixed;
  bottom: 15%; /* ✅ 기존 Toast와 동일 */
  left: 50%;
  transform: translateX(-50%);
  width: 80%; /* ✅ 기존 Toast와 동일 */
  z-index: 9999;

  padding: 12px 20px;
  background: #333; /* ✅ 기존 Toast와 동일 */
  color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  text-align: center;
}

/* 타입별 색상 (필요하면 사용) */
.toast-success {
  background-color: #28a745;
}
.toast-error {
  background-color: #dc3545;
}
.toast-warning {
  background-color: #ffc107;
  color: #212529;
}
.toast-info {
  background-color: #333;
}

/* 애니메이션 */
.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
}
</style>
